import React, { useId } from 'react'

export default function ThemeModeSlider({ isDark, onToggle, className = '' }) {
  const switchId = useId()

  return (
    <div
      className={[
        'inline-flex items-center justify-center gap-2',
        className
      ].join(' ')}
    >
      <span className={`text-xs font-semibold uppercase tracking-[0.12em] ${isDark ? 'text-slate-500' : 'text-slate-700'}`}>
        Light
      </span>

      <label
        htmlFor={switchId}
        className="relative inline-block h-7 w-14 shrink-0 cursor-pointer"
      >
        <input
          data-hs-theme-switch
          type="checkbox"
          id={switchId}
          checked={isDark}
          onChange={onToggle}
          className="peer sr-only"
          aria-label="Toggle theme"
          role="switch"
          aria-checked={isDark}
        />
        <span className="absolute inset-0 rounded-full bg-slate-300 transition-colors duration-200 peer-checked:bg-sky-500 dark:bg-slate-700" />
        <span className="absolute left-0.5 top-1/2 h-6 w-6 -translate-y-1/2 rounded-full bg-white shadow-sm transition-transform duration-200 peer-checked:translate-x-7 dark:bg-slate-100" />
      </label>

      <span className={`text-xs font-semibold uppercase tracking-[0.12em] ${isDark ? 'text-slate-900' : 'text-slate-500'}`}>
        Dark
      </span>
    </div>
  )
}
